import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Spinner, Alert } from "react-bootstrap";
import { adminFacebookService } from "../../../services/api";

const AdminFacebookCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Extract access token from URL hash
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);

        const accessToken = params.get("access_token");
        const expiresIn = params.get("expires_in");
        const error = params.get("error");
        const errorDescription = params.get("error_description");

        if (error) {
          setError(errorDescription || "Facebook authentication failed");
          setTimeout(() => {
            navigate("/admin/facebook-connect");
          }, 3000);
          return;
        }

        if (!accessToken) {
          setError("No access token received from Facebook");
          setTimeout(() => {
            navigate("/admin/facebook-connect");
          }, 3000);
          return;
        }

        // Get Facebook user ID using the access token
        const userResponse = await fetch(
          `https://graph.facebook.com/me?access_token=${accessToken}`
        );
        const userData = await userResponse.json();

        if (!userData.id) {
          setError("Failed to get Facebook user information");
          setTimeout(() => {
            navigate("/admin/facebook-connect");
          }, 3000);
          return;
        }

        // Call admin connect API
        const connectData = {
          facebookId: userData.id,
          accessToken: accessToken,
          expiresIn: parseInt(expiresIn),
        };

        const response = await adminFacebookService.connect(connectData);

        if (response.success) {
          // Redirect to Facebook connect page with success state
          navigate("/admin/facebook-connect", {
            state: {
              success: true,
              message: "เชื่อมต่อ Facebook สำเร็จ",
              pages: response.pages,
            },
          });
        } else {
          setError("Failed to connect Facebook account");
          setTimeout(() => {
            navigate("/admin/facebook-connect");
          }, 3000);
        }
      } catch (error) {
        console.error("Facebook callback error:", error);
        setError(
          error.response?.data?.error ||
            error.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อ Facebook"
        );
        setTimeout(() => {
          navigate("/admin/facebook-connect");
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center">
        {error ? (
          <Alert variant="danger">
            <Alert.Heading>เกิดข้อผิดพลาด</Alert.Heading>
            <p>{error}</p>
            <p className="mb-0">
              <small>กำลังนำคุณกลับไปหน้าเชื่อมต่อ Facebook...</small>
            </p>
          </Alert>
        ) : (
          <>
            <Spinner animation="border" variant="primary" className="mb-3" />
            <h5>กำลังเชื่อมต่อกับ Facebook...</h5>
            <p className="text-muted">กรุณารอสักครู่</p>
          </>
        )}
      </div>
    </Container>
  );
};

export default AdminFacebookCallback;
